import {
  AutoScrollActivator,
  DndContext,
  MouseSensor,
  TraversalOrder,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { FC, PropsWithChildren, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useRidesDragHandling } from "@ryde/redux";
import { CARD_BOARD_URL_PATH } from "@ryde/shared";

import { createRidesCollisionDetection } from "./utils";

const ridesCollisionDetection = createRidesCollisionDetection();

export const RidesDragContextWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const location = useLocation();
  const isCardBoardView = useMemo(
    (): boolean => location.pathname.includes(CARD_BOARD_URL_PATH),
    [location.pathname],
  );

  const { handleDragStart, handleDragEnd, handleDragOver, handleDragCancel } =
    useRidesDragHandling();

  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 8 } }),
  );

  return (
    <DndContext
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
      onDragEnd={handleDragEnd}
      onDragCancel={handleDragCancel}
      sensors={sensors}
      collisionDetection={
        !isCardBoardView ? ridesCollisionDetection : undefined
      }
      autoScroll={{
        enabled: true,
        acceleration: 3,
        interval: 2,
        activator: AutoScrollActivator.Pointer,
        layoutShiftCompensation: true,
        threshold: { x: 0.1, y: 0.1 },
        order: TraversalOrder.ReversedTreeOrder,
      }}
    >
      {children}
    </DndContext>
  );
};
